export default "__VITE_ASSET__Cc$skd1V__"